import { Component, inject, ViewEncapsulation } from '@angular/core';

import {
	MDIconComponent,
	MDDialogRef,
	MD_DIALOG_REF,
	MDDatePickerInputDirective,
	MDDialogModule,
	IMDDropDownOption,
	MDDropDownComponent
} from '@melodic-ui/components';

@Component({
	selector: 'lrnr-extended-leave-dialog',
	standalone: true,
	imports: [MDIconComponent, MDDatePickerInputDirective, MDDialogModule, MDDropDownComponent],
	templateUrl: './extended-leave-dialog.component.html',
	styleUrl: './extended-leave-dialog.component.scss',
	encapsulation: ViewEncapsulation.None
})
export class ExtendedLeaveDialogComponent {
	private dialogRef: MDDialogRef = inject(MD_DIALOG_REF);

	public reasonOptions: IMDDropDownOption[] = [
		{ value: 'one', label: 'Personal Circumstances' },
		{ value: 'two', label: 'Second option' }
	];

	close(): void {
		this.dialogRef.close();
	}
}
